// components/brvm/BrvmTicker.jsx — Ticker BRVM fin et animé (Home AYA).
// Données réelles brvm.org via /api/brvm/ticker. Si indisponible → le ticker se cache.
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BarChart3, ChevronRight } from "lucide-react";
import { fetchTicker, fmtNum, fmtPct, deltaColor } from "./brvmApi";

const SS_KEY = "aya_brvm_ticker_cache";

function TickItem({ item, onStock }) {
  const color = deltaColor(item.delta_pct);
  const arrow = item.delta_pct == null || item.delta_pct === 0 ? "" : item.delta_pct > 0 ? " ↑" : " ↓";
  const label = item.type === "index" ? item.code : item.label;
  return (
    <button
      type="button"
      data-testid={`brvm-ticker-item-${item.type === "index" ? item.code : item.symbol}`}
      onClick={(e) => { e.stopPropagation(); onStock(item); }}
      style={{
        display: "inline-flex", alignItems: "center", gap: 5, background: "none", border: "none",
        cursor: "pointer", padding: "0 11px", fontSize: 11, whiteSpace: "nowrap", fontFamily: "inherit",
      }}
    >
      <span style={{ fontWeight: 800, color: "var(--ah-text, #ECF5EE)", letterSpacing: 0.2 }}>{label}</span>
      {item.type === "stock" && <span style={{ color: "var(--ah-soft, #CFE5D6)", fontWeight: 600 }}>{fmtNum(item.close)}</span>}
      {item.type === "index" && <span style={{ color: "var(--ah-soft, #CFE5D6)", fontWeight: 600 }}>{fmtNum(item.value, 2)}</span>}
      {item.delta_pct != null && <span style={{ color, fontWeight: 800 }}>{fmtPct(item.delta_pct)}{arrow}</span>}
      <span style={{ color: "var(--ah-border, rgba(207,229,214,0.22))", marginLeft: 6 }}>|</span>
    </button>
  );
}

export default function BrvmTicker() {
  const navigate = useNavigate();
  const [items, setItems] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem(SS_KEY) || "null")?.items || null; } catch { return null; }
  });

  useEffect(() => {
    let alive = true;
    fetchTicker()
      .then((d) => {
        if (!alive || !d.ok || !Array.isArray(d.items) || d.items.length === 0) return;
        setItems(d.items);
        try { sessionStorage.setItem(SS_KEY, JSON.stringify({ items: d.items })); } catch { /* quota */ }
      })
      .catch(() => { /* silencieux : le ticker se cache si pas de données */ });
    return () => { alive = false; };
  }, []);

  if (!items || items.length === 0) return null;

  const onStock = (item) => navigate(item.type === "stock" ? `/brvm?symbol=${item.symbol}` : "/brvm");
  const dur = Math.max(28, items.length * 4);

  return (
    <div
      className="brvm-ticker"
      data-testid="brvm-ticker"
      role="button"
      tabIndex={0}
      aria-label="Ouvrir l'espace BRVM"
      onClick={() => navigate("/brvm")}
      onKeyDown={(e) => { if (e.key === "Enter") navigate("/brvm"); }}
    >
      <span className="brvm-ticker-label" data-testid="brvm-ticker-label">
        <BarChart3 size={13} color="#F97316" strokeWidth={2.6} />
        <span>BRVM</span>
        <ChevronRight size={12} color="#9DB4A6" strokeWidth={2.6} />
      </span>
      <div className="brvm-ticker-viewport">
        <div className="brvm-ticker-track" style={{ animationDuration: `${dur}s` }}>
          {[...items, ...items].map((it, i) => (
            <TickItem key={`${it.symbol || it.code}-${i}`} item={it} onStock={onStock} />
          ))}
        </div>
      </div>
    </div>
  );
}
